export enum REPORT_TYPES
{
  NONE = 0,
  COMPARISON = 1,
  ROSTERITEM = 2,
  STUDENTITEMDETAIL = 3,
  STUDENTITEM = 4
}